//
//
//
//
//
//
//
//
//
//
//

import DesktopHeading from './desktopHeading.vue';
import MobileHeading from './mobileHeading.vue';

export default {
  components: {
    DesktopHeading,
    MobileHeading,
  },
  props: {
    mobileTitleText: {
      type: String,
      required: true,
    },
    desktopTitleText: {
      type: String,
      required: true,
    },
    mainTextColor: {
      type: String,
      default: '',
    },
  },
};
